import { User_Professional_Public, User_User_Public } from "@graphql/schema.types"
import { useTranslation } from "@refinedev/core"
import dayjs from "dayjs"
import { calendar_v3 } from "googleapis"
import { HTMLAttributes, useMemo, useState } from "react"
import { PiTimerBold } from "react-icons/pi"

export interface AppointmentEventProps extends HTMLAttributes<HTMLDivElement> {
    event: calendar_v3.Schema$Event
    update?: boolean
    name: 'professional' | 'user'
    contact?: User_Professional_Public | User_User_Public
}

export const AppointmentEvent = ({ event, name, contact, update = false, className, ...rest }: AppointmentEventProps) => {
    const date = useMemo(() => dayjs(), [update])
    const { translate } = useTranslation()
    const [copy, setCopy] = useState(translate("calendar-defs.emergency_call-modal.copy"))
    const meetLink = event?.conferenceData?.entryPoints?.[0]?.uri!
    // logger.debug(date.toISOString())

    const copyText = () => {
        navigator.clipboard.writeText(meetLink);
        setCopy(translate("calendar-defs.emergency_call-modal.copied") + "!")
        setTimeout(() => {
            setCopy(translate("calendar-defs.emergency_call-modal.copy"))
        }, 2000)
    }

    return <div className={`flex flex-col items-center ${className ?? ''}`} {...rest}>
        <div className="card bg-base-100 overflow-hidden shadow-lg border border-base-300">
            <div className="card-title flex relative">
                <div className="grow px-4 py-2">
                    <h3 className="text-2xl">{translate("calendar-defs.appointment-modal.subtitle")}</h3>
                    <span className="font-normal text-sm">{`${date.to(dayjs(event.start?.dateTime))}, `}
                        <strong>{`${dayjs(event.start?.dateTime).format('HH:mm')} - ${dayjs(event.end?.dateTime).format('HH:mm')}`}</strong>
                    </span>
                </div>
                <div className="h-14 bg-primary text-secondary w-16 flex items-center justify-center rounded-l-full">
                    <PiTimerBold className="w-8 h-8" />
                </div>
            </div>
            <div className="card-body pt-2 rounded-xl">
                <fieldset className="fieldset">
                    <legend>{translate("calendar-defs.appointment-modal." + name)}</legend>
                    <div className={`ml-2 flex items-center gap-2 ${contact ? '' : 'skeleton'}`}>
                        <div className="avatar">
                            <div className="w-8 rounded-full bg-primary">
                                {contact?.avatar_url ? (
                                    <img src={contact.avatar_url} />
                                ) : (
                                    <div className="flex items-center justify-center h-full w-full text-white">
                                        {contact?.display_name?.charAt(0) || '?'}
                                    </div>
                                )}
                            </div>
                        </div>
                        <p className="max-w-64 truncate">{contact?.display_name ?? ''}</p>
                    </div>
                    <a className="my-2 btn btn-secondary hover:scale-[1.02]" href={meetLink} target="_blank">
                        {translate("calendar-defs.appointment-modal.short-description")}
                    </a>
                    <div className="label">
                        <span className="cursor-copy tooltip" data-tip={copy} onClick={copyText}>{meetLink}</span>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>
}